import { ValidationCallback } from '~/types/types'

export const required: ValidationCallback = (value: any, param?: any, customMessage?: string) => {
  return !!value || (customMessage || 'Поле обязательно для заполнения')
}
